<template>
  <v-app class="primary">
    <router-view class="navbar" name="navbar"></router-view>
    <v-content class="ml-4">
      <router-view/>
    </v-content>
    <router-view class="footer" name="footer"></router-view>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      //
    };
  }
};
</script>
